import { IDadosDisciplina } from '@/@types/Academico/Disciplina';
import { DisciplinasPosGraduacaoComponent } from '@/components/PagesComponents/PosGraduacao/DisciplinasPosGraduacaoComponent';
import { apiServerDac } from '@/services/api';
import { useEffect, useState } from 'react';


const DisciplinasPosGraduacao = () => {
    const anoAtual = new Date().getFullYear();    
    const [data, setData] = useState<IDadosDisciplina[]>([]);
    const [ano, setAno] = useState<number>(anoAtual);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const getDisciplinasPosGraduacaoData = async () => {
            setIsLoading(true);
            // server-dac V2 substitui /disciplinas/allyearsdistinct preservando { disciplinas }.
            const url = `/v2/disciplinas_catalogo/anos-distinct?ano=${!ano ? anoAtual : ano}&cod_disci=&tipo=AP`;

            await apiServerDac.get(url)
                .then(response => {
                    setData(response.data.disciplinas);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                })

        }

        getDisciplinasPosGraduacaoData();
    }, [ano])

    return (
        <>
            <h1>Pós-Graduação - Disciplinas</h1>

            <DisciplinasPosGraduacaoComponent
                data={data}
                isLoading={isLoading}
                ano={ano}
                setAno={setAno}
            />

        </>
    )

}

export { DisciplinasPosGraduacao };
